import {Validators} from "@angular/forms";
import {Pipe} from "@angular/core";

export const PATENT_VALIDATOR_AUTO_PATTERN = '^[A-Z]{3}[0-9]{3}$|^[A-Z]{2}[0-9]{3}[A-Z]{2}$';
export const PATENT_VALIDATOR_MOTO_PATTERN = '^[0-9]{3}[A-Z]{3}$|^[A-Z]{1}[0-9]{3}[A-Z]{3}$';
export const PATENT_VALIDATOR_AUTO = Validators.pattern(PATENT_VALIDATOR_AUTO_PATTERN);
export const PATENT_VALIDATOR_MOTO = Validators.pattern(PATENT_VALIDATOR_MOTO_PATTERN);
export const CUIT_VALIDATOR = Validators.pattern('[0-9]{11}');
export const YEAR_VALIDATOR = Validators.pattern('[0-9]{4}');
export const INTEGER_VALIDATOR = Validators.pattern('[0-9]+');
export const AMOUNT_VALIDATOR = Validators.pattern('[0-9]+(\.[0-9][0-9]?)?');
export const EMAIL_VALIDATOR = Validators.pattern('^([_a-zA-Z0-9-]{2,4})([_a-zA-Z0-9-](.[_a-zA-Z0-9-]+))*@([a-zA-Z0-9-]{2,})+(.[a-zA-Z0-9-]+)*(.[a-zA-Z]{2,4})$');

export const DATE_VALIDATOR = Validators.pattern('(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9]))|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96))');
export const DATE_VALID_CHARACTERS = Validators.pattern('[0-9][0-9][\/][0-9][0-9][\/][0-9][0-9][0-9][0-9]');

export const DEFAULT_ERROR_MESSAGES = {
    required: 'Campo requerido.',
    invalidPattern: 'Formato inválido.',
    groupEmailPattern: 'Formato inválido. Los emails se deben separarse con un espacio.',
    invalidAmount: 'Formato inválido. No se permiten mas de dos decimales.',
    invalidDate: 'Formato inválido. Utilice el siguiente patrón de fecha: dd/MM/yyyy',
    requiredDate: 'Campo requerido para el rango de fechas.',
    invalidCuit: 'Debe contener once (11) digitos.'
};

@Pipe({
    name: 'amountFormat'
})
export class AmountFormat {
    transform(value: number,
              currencySign: string = '$',
              decimalLength: number = 2,
              chunkDelimiter: string = '.',
              decimalDelimiter: string = ',',
              chunkLength: number = 3): string {

        let result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
        if (value != null) {
            let num = value.toFixed(Math.max(0, ~~decimalLength));
            return currencySign + (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(result, 'g'), '$&' + chunkDelimiter);
        }
        return currencySign + '0' + decimalDelimiter + '00'; //NULL -> $0,00
    }
}

@Pipe({
    name: 'kmFormat'
})
export class KmFormat {
    transform(value: number,
              decimalLength: number = 0,
              chunkDelimiter: string = '.',
              decimalDelimiter: string = ',',
              chunkLength: number = 3): string {

        let result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
        if (value != null) {
            let num = value.toFixed(Math.max(0, ~~decimalLength));
            return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(result, 'g'), '$&' + chunkDelimiter) + ' km.';
        }
        return 'SIN KM CARGADOS';
    }
}

@Pipe({
    name: 'isExpirated'
})
export class IsExpirated {
    transform(value: boolean, date: string): string {

        if (value) {
            return 'RESUELTO';
        }

        let todayDate = new Date(Date.parse(Date()));
        let expiratedDateStr: string[];
        let expiratedDate: Date;

        if (date !== undefined && date !== null) {
            if (date.includes('/')) {
                expiratedDateStr = date.split('/');
                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
            } else if (date.includes('-')) {
                expiratedDateStr = date.split('-');
                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
            }
        }

        return expiratedDate > todayDate ? 'A VENCER' : 'VENCIDO';
    }
}

export const VALID_MIME_TYPES = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg', 'image/gif', 'image/png', 'image/bmp', 'image/x-windows-bmp', 'application/msword', 'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/zip',
    'application/x-rar-compressed', 'application/octet-stream'];

export const FILE_MAX_SIZE: number = 10485760; //10 MB


/** WEBPACK FOOTER **
 ** ./src/app/validators/validators.ts
 **/